function n(n){void 0===n&&(n={});var t=Object.keys(n).filter((function(t){return void 0!==n[t]}));return t.length?"?"+t.map((function(t){return"".concat(t,"=").concat(n[t])})).join("&"):""}export{n as serializeQs};
